// store/auth.js
import { post } from '@/api/api';

const state = {
  userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : null,
  token: localStorage.getItem('token') || null,
  isAuthenticated: !!localStorage.getItem('token')
};

const mutations = {
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo;
    if (userInfo) {
      localStorage.setItem('userInfo', JSON.stringify(userInfo));
    } else {
      localStorage.removeItem('userInfo');
    }
  },
  
  SET_TOKEN(state, token) {
    state.token = token;
    if (token) {
      localStorage.setItem('token', token);
    } else {
      localStorage.removeItem('token');
    }
  },
  
  SET_AUTHENTICATED(state, status) {
    state.isAuthenticated = status;
  }
};

const actions = {
  // 登录
  async login({ commit }, loginData) {
    try {
      // 调用真实的登录API
      const response = await post('/api/admin/auth/login', loginData);
      
      if (response.data.success) {
        const { userInfo, token } = response.data.result;
        
        commit('SET_USER_INFO', userInfo);
        commit('SET_TOKEN', token);
        commit('SET_AUTHENTICATED', true);
        
        return { success: true, data: { userInfo, token } };
      } else {
        return { success: false, message: response.data.message || '登录失败' };
      }
    } catch (error) {
      commit('SET_USER_INFO', null);
      commit('SET_TOKEN', null);
      commit('SET_AUTHENTICATED', false);
      
      return { success: false, message: error.message || '登录失败' };
    }
  },
  
  // 注册
  async register({ commit }, registerData) {
    try {
      // 这里应该调用真实的注册API
      // const response = await post('/api/register', registerData);
      
      // 模拟注册成功
      return { success: true, message: '注册成功' };
    } catch (error) {
      return { success: false, message: error.message };
    }
  },
  
  // 登出
  logout({ commit }) {
    commit('SET_USER_INFO', null);
    commit('SET_TOKEN', null);
    commit('SET_AUTHENTICATED', false);
  }
};

const getters = {
  userInfo: state => state.userInfo,
  isAuthenticated: state => state.isAuthenticated,
  token: state => state.token
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};